var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{ref:"controls",staticClass:"controls"},[_c('div',{staticClass:"controls_right"},[_c('img',{attrs:{"width":"40px","src":_vm.danMuSrc,"alt":""},on:{"click":_vm.isShowDanMuFn}})])])}
var staticRenderFns = []

export { render, staticRenderFns }